import * as React from 'react';
import * as ReactDOM from 'react-dom';
import 'babel-polyfill'; 
import {
    BrowserRouter as Router,
    Route
} from "react-router-dom";
import Home from './home';
import Search from './search';
import Provider from './provider';
import PersonalInfo from './personalinfo';
//import Verify from './verify';
import InsuranceInfo from './insuranceinfo';
import BookingComplete from './bookingcomplete';
import NewPatientCheck from './newpatientcheck';
import ContactProvider from './contactprovider';
import ScrollToTop from './scrolltotop';
import ContactInfo from './contactinfo';
import Virtualist from './virtualist';

const App = () => (
    <Router basename={(window as any).BASE_PATH}>
        <ScrollToTop />
        <Route path="/search" component={Search} />
        <Route path="/virtualist" component={Virtualist} />
        <Route path="/provider" component={Provider} />
        <Route path="/personalinfo" component={PersonalInfo} />
        <Route path="/contactinfo" component={ContactInfo} />
        <Route path="/insuranceinfo" component={InsuranceInfo} />
        <Route path="/bookingcomplete" component={BookingComplete} />
        <Route path="/newpatientcheck" component={NewPatientCheck} />        
        <Route path="/contactprovider" component={ContactProvider} />        
        <Route exact path="/" component={Home} />
    </Router>
)
var a = 1;
ReactDOM.render(<App />, document.getElementById('root'));